import { FALL_DETECTION_SPEED_WALK, FALL_DETECTION_Z_FALL, FALL_DETECTION_Z_WAKE } from '@/consts/pti/fallDetector'

/**
 * Vérifie si l'agent marche.
 * @returns {boolean}
 */
export const checkIfWalking = (x, y, detectionSpeedWalk = FALL_DETECTION_SPEED_WALK) => {
  const absSpeed = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
  return absSpeed > detectionSpeedWalk
}

/**
 * Vérifie si l'agent tombe.
 * @returns {boolean}
 */
export const checkIfFalling = (z, fallDetection = FALL_DETECTION_Z_FALL) => {
  return z < fallDetection
}

/**
 * Vérifie si l'agent se relève.
 * @returns {boolean}
 */
export const checkIfWakeUp = (z, wakeUpDetection = FALL_DETECTION_Z_WAKE) => {
  return z > wakeUpDetection
}
